<script>
// @flow
/* @jsx h */

export default {
  functional: true,
  name: 'SmartP',
  render(h: Function, { children, data }: any) {
    return (
      <p
        {...data}
        class="smart font-normal text-opacity-hg">
        { children }
      </p>
    );
  }
};

</script>

<style lang="scss">
.smart {
  font-size: $font-size-paragraph;
  line-height: 1.4;
  opacity: $font-opacity-md;
}
</style>
